import _ from 'lodash-es';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import Defaults from '~/scripts/constants/defaults';
import Link from '~/scripts/services/model/link';
import Node from '~/scripts/services/model/node';

/* globals Knitiv */

export default class ModalMailingListItemController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} NodeService
	 * @param {any} User
	 * @param {Node} nodeMailingList
	 */
	constructor(
		$rootScope,
		$timeout,
		$uibModalInstance,
		NodeService,
		User,
		nodeMailingList,
	) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.NodeService = NodeService;
		this.User = User;

		/** @type {import('@knitiv/api-client-javascript').KNode[]} */
		this.itemsToRemove = [];

		/** @type {any} */
		this.mailing = {
			type:      'PRIVATE',
			recipients: [],
			role:       [],
		};

		/** @type {Node} */
		this.nodeMailingList = _.cloneDeep(nodeMailingList);
		this.mailingForm = undefined;

		/**
		 * @type {any}
		 */
		this.model = undefined;
		this.types = ['PRIVATE', 'PUBLIC', 'CUSTOM'];

		// Set type
		if (
			this.nodeMailingList.droit.length === 1
			&& this.nodeMailingList.droit[0].role.kid === this.$rootScope?.context?.profil.kid
		) {
			this.mailing.type = 'PRIVATE';
		}
		else if (
			this.nodeMailingList.droit.length === 1
			&& this.nodeMailingList.droit[0].role.kid === 'K_NODE;KR_WF_TOUS'
		) {
			this.mailing.type = 'PUBLIC';
		}
		else if (this.nodeMailingList.droit.length > 0) {
			this.mailing.type = 'CUSTOM';
			this.mailing.role = this.nodeMailingList.droit.map(droit => ({ kid: droit.role.kid, name: droit.role.name }));
		}

		(async () => {
			await this.getLinks();
			await this.updateDroits();
		})();
	}

	/**
	 * @param {any} item
	 */
	async addDroit(item) {
		if (item) {
			this.nodeMailingList.addDroit({
				kright:   Defaults.DROIT.ALL,
				role:     { kid: item.kid },
			});
		}
	}

	/**
	 * @param {any} recipient
	 */
	addRecipient(recipient) {
		// if (!recipient.person.kid) {
		// 	delete recipient.person.name;
		// }

		const nodeMailingItem = this.NodeService.create('K_NODE;MAILINGITEM');
		if (recipient.email?.kid) {
			const nodeEmail = nodeMailingItem.addNode(recipient.email.kid, 'K_NODE;EMAIL');
			nodeMailingItem.addRelation(COMPOSED_OF, this.nodeMailingList);
			nodeMailingItem.addRelation(COMPOSED_OF, nodeEmail);
		}
		if (recipient.person?.kid) {
			const nodePerson = nodeMailingItem.addNode(recipient.person.kid, 'K_NODE;PERSON');
			nodeMailingItem.addRelation(COMPOSED_OF, nodePerson);
			nodeMailingItem.name = recipient.person.name;
			if (recipient.email) {
				nodeMailingItem.name += ` <${recipient.email.name}>`;
			}
		}
		else {
			nodeMailingItem.setName(recipient.email.name);
		}
		nodeMailingItem.parent = this.nodeMailingList;

		// Virtual link creation
		this.nodeMailingList.link.push(new Link({
			objname:      nodeMailingItem.getName(),
			objnum2_kid:  this.nodeMailingList.kid,
			objnum_isa:   'K_NODE;MAILINGITEM',
			flow:         'to',
			relation_kid: COMPOSED_OF,
		}));

		this.mailing.recipients.push(nodeMailingItem);
		this.model = undefined;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	/**
	 * @param {Link} recipient
	 */
	delRecipient(recipient) {
		if (recipient.objnum_kid) {
			this.itemsToRemove.push(recipient.objnum_kid);
			_.remove(this.nodeMailingList.link, l => recipient.objnum_kid === l.objnum_kid);
			_.remove(this.mailing.recipients, r => recipient.objnum_kid === r.kid);
		}
		else {
			// @ts-ignore
			_.remove(this.nodeMailingList.link, l => recipient.$$hashKey === l.$$hashKey);
		}
	}

	async getLinks() {
		// Get mail list
		await this.nodeMailingList.fetchLinks();
		for (const link of this.nodeMailingList.link) {
			const mailingItem = await this.NodeService.load(link.objnum_kid);
			this.$timeout(() => {
				this.mailing.recipients.push(mailingItem);
			});
		}
	}

	/**
	 * @param {any} item
	 */
	removeDroit(item) {
		this.nodeMailingList.delDroit(item.kid);
	}

	submit() {
		this.$uibModalInstance.close({
			nodes:         [this.nodeMailingList, ...this.mailing.recipients],
			itemsToRemove: this.itemsToRemove,
		});
	}

	async updateDroits() {
		const roles = [];
		this.nodeMailingList.droit.length = 0;

		if (this.mailing.type === 'PRIVATE') {
			roles.push(this.$rootScope.context?.profil.kid);
		}
		else if (this.mailing.type === 'PUBLIC') {
			roles.push('K_NODE;KR_WF_TOUS');
		}
		else if (this.mailing.type === 'CUSTOM' && this.mailing.role?.length > 0) {
			roles.push(...this.mailing.role.map((/** @type {any} */ role) => role.kid));
		}
		if (roles.length > 0) {
			for (const role of roles) {
				await this.nodeMailingList.addDroit({
					kright: Defaults.DROIT.ALL,
					role:   { kid: role },
				});
			}
		}
	}

	updateName() {
		this.nodeMailingList.setName(this.nodeMailingList.name || '');
	}
}
